export const BlogData = [
  {
    id: 1,
    img: 'blog/blog-5.jpg',
    date: '9',
    month: 'April',
    admin: 'by: Admin',
    hits: '0 Hits',
    details: 'Perspiciatis unde omnis',
    details1:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt.',
  },
  {
    id: 2,
    img: 'blog/blog-6.jpg',
    date: '30',
    month: 'April',
    admin: 'by: Admin',
    hits: '0 Hits',
    details: 'Perspiciatis unde omnis',
    details1:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt.',
  },
  {
    id: 3,
    img: 'blog/blog-5.jpg',
    date: '6',
    month: 'April',
    admin: 'by: Admin',
    hits: '0 Hits',
    details: 'Perspiciatis unde omnis',
    details1:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt.',
  },
  {
    id: 4,
    img: 'blog/blog-6.jpg',
    date: '5',
    month: 'April',
    admin: 'by: Admin',
    hits: '0 Hits',
    details: 'Perspiciatis unde omnis',
    details1:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt.',
  },
];

export const BlogSingleData = [
  {
    id: 1,
    name: 'JolioMark',
    post: 'Designer',
    hits: '02 Hits',
    comments: '598 Comments',
    para: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`,
  },
  {
    id: 2,
    name: 'JolioMark',
    post: 'Designer',
    hits: '02 Hits',
    class: true,
    comments: '598 Comments',
    para: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`,
  },
  {
    id: 3,
    name: 'JolioMark',
    post: 'Designer',
    hits: '02 Hits',
    comments: '598 Comments',
    para: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`,
  },
  {
    id: 4,
    name: 'JolioMark',
    post: 'Designer',
    hits: '02 Hits',
    comments: '598 Comments',
    para: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`,
  },
  {
    id: 5,
    name: 'JolioMark',
    post: 'Designer',
    hits: '02 Hits',
    comments: '598 Comments',
    para: `There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable.If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text.`,
  },
];
